import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Heart, Target, Award } from "lucide-react";

const STREET = "https://images.unsplash.com/photo-1520683499094-581c1f52cd67";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="bg-brand-dark text-white py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="kicker text-brand-red">Om EMA Kurer ApS</div>
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-[1.05] max-w-3xl">
            Pålidelig kurer. <span className="text-brand-red">Premium</span> service. Dansk håndværk.
          </h1>
          <p className="text-white/70 mt-6 text-lg max-w-2xl leading-relaxed">
            EMA Kurer ApS er en moderne dansk logistikvirksomhed bygget på <strong className="text-white">tillid</strong>, <strong className="text-white">omhu</strong> og <strong className="text-white">ansvar</strong>. Vi tager dine pakker personligt — fra dør til dør på Sjælland, samme aften du booker.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <img src={STREET} alt="København" className="w-full aspect-[4/3] object-cover" />
        </div>
        <div className="lg:col-span-6">
          <div className="kicker">Vores historie</div>
          <h2 className="font-display font-semibold text-3xl lg:text-4xl mt-4 text-brand-dark tracking-tight">
            Bygget i Danmark — drevet af passion.
          </h2>
          <p className="text-brand-text2 mt-5 leading-relaxed">
            EMA Kurer ApS er en moderne kurerservice grundlagt med ét mål: at gøre same-day levering enkel, pålidelig og tilgængelig for både private og virksomheder på Sjælland.
          </p>
          <p className="text-brand-text2 mt-4 leading-relaxed">
            Vi tror på skandinavisk simpelhed, fair priser og at hver pakke fortjener at blive behandlet som var den vores egen. Vi er bygget til at vokse — uden at gå på kompromis med kvaliteten.
          </p>
        </div>
      </section>

      <section className="bg-brand-bg2 border-y border-brand py-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="kicker text-center">Vores værdier</div>
          <h2 className="font-display font-semibold text-3xl lg:text-4xl text-center mt-3 text-brand-dark tracking-tight">Hvad vi står for</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {[
              { i: Heart, t: "Personlig service", d: "Vi behandler kunder og partnere med respekt. Ærlighed og omhu er grundstenen i alt vi gør." },
              { i: Target, t: "Pålidelighed", d: "Når vi siger samme aften, mener vi samme aften. Vi holder vores løfter." },
              { i: Award, t: "Premium service", d: "Vi leverer ikke bare pakker — vi leverer en oplevelse, der gør kunder til ambassadører." },
            ].map((v) => (
              <div key={v.t} className="card-flat p-8" data-testid={`value-${v.t.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="w-12 h-12 bg-brand-red text-white flex items-center justify-center"><v.i size={20} /></div>
                <div className="font-display font-semibold text-2xl text-brand-dark mt-5">{v.t}</div>
                <div className="text-brand-text2 mt-3 leading-relaxed">{v.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 py-20 text-center">
        <div className="kicker">Firmaoplysninger</div>
        <h2 className="font-display font-semibold text-3xl lg:text-4xl mt-3 text-brand-dark tracking-tight">EMA Kurer ApS</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
          {[
            { k: "CVR", v: "46465717" },
            { k: "Område", v: "Sjælland" },
            { k: "Email", v: "kontakt@emakurer.dk" },
            { k: "Web", v: "emakurer.dk" },
          ].map((x) => (
            <div key={x.k} className="border-t-2 border-brand-red pt-4">
              <div className="text-xs uppercase tracking-widest text-brand-text2">{x.k}</div>
              <div className="font-display font-semibold text-brand-dark mt-1 break-words">{x.v}</div>
            </div>
          ))}
        </div>
        <Link to="/book" data-testid="about-cta" className="btn-primary mt-10">Book afhentning <ArrowRight size={16} /></Link>
      </section>
    </div>
  );
}
